import {useState} from 'react'
import MediaRegistrationList from './MediaRegistrationList';
import MediaRegistrationForm from './MediaRegistrationForm';

const MediaRegistration = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);
  const [serviceId, setServiceId] = useState("none");
return (
  <>
    {fromIsShown ? (
        <MediaRegistrationForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
      ) : (
        <MediaRegistrationList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
      )}

  </>
  )
}

export default MediaRegistration